/* eslint-disable */
import type { RequestContext } from "../franklin/RequestContextProto.pb";
import type { ResponseContext } from "../franklin/ResponseContextProto.pb";

export interface DirectDepositTransferSelectionRequest {
  request_context?: RequestContext;
  account_transfer_selection?: DirectDepositTransferSelectionRequestAccountTransferSelection;
}

export enum DirectDepositTransferSelectionRequestAccountTransferSelection {
  AUTOMATIC = "AUTOMATIC",
  MANUAL = "MANUAL",
}

export interface DirectDepositTransferSelectionResponse {
  response_context?: ResponseContext;
}

export interface InstantPayAppService {
  DirectDepositTransferSelection(
    request: DirectDepositTransferSelectionRequest,
  ): Promise<DirectDepositTransferSelectionResponse>;
}
